
import React from 'react';
import { Region } from '../../data/types/region-types';
import { City } from '../../data/types/city-types';
import RegionSidebar from '../region-sidebar';
import CitySidebar from '../city-sidebar';
import { getCitiesByRegion } from '../../utils/city-utils';

interface SidebarsProps {
  selectedRegion: Region | null;
  selectedCity: City | null;
  handleGoBack: () => void;
  handleCitySelect: (cityId: string) => void;
}

const Sidebars: React.FC<SidebarsProps> = ({
  selectedRegion,
  selectedCity,
  handleGoBack,
  handleCitySelect
}) => {
  return (
    <>
      {selectedRegion && !selectedCity && (
        <RegionSidebar 
          region={selectedRegion} 
          onClose={() => handleGoBack()} 
          onCitySelect={handleCitySelect}
          cities={getCitiesByRegion(selectedRegion.region_id)}
          style="city" // Use city-style layout
        />
      )}
      
      {selectedCity && (
        <CitySidebar 
          city={selectedCity} 
          onClose={() => handleGoBack()} 
        />
      )}
    </>
  );
};

export default Sidebars;
